import { CreateAddressInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const CreateAddressInputSchema: z.ZodType<CreateAddressInput> = z.object({
  address_postal_code: z.string(),
  address_state: z.string(),
  address_city: z.string(),
  address_line1: z.string(),
  address_line2: z.string(),
});
